import { type FC } from "react";

const Spinner: FC = () => (
  <div className="relative h-14 w-14">
    <div className="absolute inset-0 rounded-full border-4 border-[#0056D2]/20 border-t-[#0056D2] animate-spin" />
    <div
      className="absolute inset-2 rounded-full border-4 border-[#1a6ee6]/20 border-t-[#1a6ee6] animate-spin"
      style={{ animationDirection: "reverse", animationDuration: "0.8s" }}
    />
  </div>
);

/** Full viewport: initial lazy load of layout / auth routes (avoids white flash). */
export const AppShellFallback: FC = () => (
  <div className="min-h-screen w-full bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center gap-4">
    <Spinner />
    <p className="text-sm font-medium text-gray-500 dark:text-gray-400 animate-pulse">
      Loading…
    </p>
  </div>
);

/** Inside main layout while a lazy page chunk loads — shell (sidebar/header) stays mounted. */
export const PageRouteFallback: FC = () => (
  <div className="flex min-h-[min(70vh,calc(100vh-12rem))] w-full items-center justify-center rounded-xl border border-gray-100 bg-gray-50/90 dark:border-gray-800 dark:bg-gray-900/40">
    <div className="flex flex-col items-center gap-4 py-16">
      <Spinner />
      <p className="text-sm text-gray-500 dark:text-gray-400">Loading page…</p>
    </div>
  </div>
);
